import { Set as ISet } from 'immutable';

import {
    UYO_STEPS,
    getUYOPath
} from '../routing/flow';
import { push } from '../routing/routing';
import { catalogsAreLoaded } from '../catalogs/catalogSelectors';
import {
    hasDigital as hasDigitalFaceplates,
    hasPlastic as hasPlasticFaceplates,
    hasSingleFaceplateForNewItem
} from '../faceplate/faceplateSelectors';
import { programIsActive } from '../program/programSelectors';
import { canUploadUYOPhoto } from '../item/itemSelectors';
import { removeUYOData } from '../uyo/uyoModule';
import { FACEPLATE_FIELD } from '../item/newItemForm';

import choiceMessages from './choiceMessages';
import { designStepPostConditions, designStepPreConditions, designStepSkippable } from './designStepSelectors';



const designStepConfig = {
    component: () => import('./DesignStep'),
    flow: 'buy',
    flowProps: () => {
        const uyoPath = `${getUYOPath()}-${UYO_STEPS.INIT}`;

        return {
            goToUYO: () => { push({ pathname: uyoPath }); }
        };
    },
    isReady: (state) => {
        const catalogLoaded = catalogsAreLoaded(state);
        const hasElect = hasDigitalFaceplates(state);
        const hasPlastic = hasPlasticFaceplates(state);

        return catalogLoaded && (hasElect || hasPlastic);
    },
    canLoad: (state, ownProps) => {
        const onlyOne = hasSingleFaceplateForNewItem(state);
        const programActive = programIsActive(state);
        const isUYOSupported = canUploadUYOPhoto(state);
        const skipStep = programActive && onlyOne && !isUYOSupported;

        let flowProgress = null;
        if (skipStep) {
            
            flowProgress = ISet([FACEPLATE_FIELD]);
        }
        return { isAllowedOrPath: (!skipStep || ownProps.submitPath), flowProgress };
    },
    onExit: dispatch => (
        
        
        
        dispatch(removeUYOData())
    ),
    preConditions: designStepPreConditions,
    postConditions: designStepPostConditions,
    getSubmitMessage: ({ isPlastic }) => (
        isPlastic
            ? choiceMessages.submitButtonPhysicalText
            : choiceMessages.submitButtonDigitalText),
    canSkip: state => (
        designStepSkippable(state)
    )
};

export default designStepConfig;
